import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { ImUsers, ImUserPlus } from "react-icons/im";
import AccountsCreateForm from "pages/accounts/AccountsCreateForm";
import ProfileView from "pages/accounts/ProfileView";
import { useDispatch } from "react-redux";
import { createCustomerThunk } from "store/reducers/accounts";
import CreateCustomers from "./CreateCustomers";
function CustomerAccount() {
  const dispatch = useDispatch();
  const formCallback = (input) => {
    dispatch(createCustomerThunk(input));
  };
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Customer"
        viewIcon={<ImUsers />}
        createIcon={<ImUserPlus />}
        createChildren={
          <CreateCustomers/>
        }
        listChildren={<ProfileView mod="customer" />}
      />
    </Box>
  );
}

export default CustomerAccount;
